export const ApiDef_NLPModel = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map